@use '@design/design-tokens/border-radius/border-radius' as *;

.priceWrapper {
  display: flex;
  flex-direction: column;
  min-height: 48px;

  &.condensed {
    min-height: unset;
  }
}

.priceSkeleton {
  @include border-radius-r2;

  width: 120px;
  height: 40px;
}
